

import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS'
import { updateFlyerOrder } from '../../../actions'
import { GRID_IMAGE, IMAGE, METRO, MOVIE_PERFORMANCES, TEXT, TITLE } from '../../../constants/itemTypes'
import ListDropItems from '../../DragAndDropList/presents/ListDropItems'
import FlyerDropSwitch from '../present/FlyerDropSwitch'
import ListDropConditionalWrapper from '../../DragAndDropList/presents/ListDropConditionalWrapper'
import Translation from '../../Translation/cont/Translation'




const mapDispatchToProps = (dispatch, ownProps) => ({
    reorderFlyerItems: (dragIndex, hoverIndex) => {
        let order = ownProps.flyerData.flyerStructure[ownProps.side][ownProps.section]

        if(ownProps.area) {
            order = order[ownProps.area].order
        } else {
            order = order.order
        }

        const movedElement = order.splice(dragIndex, 1)[0]
        order.splice(hoverIndex, 0, movedElement)

        dispatch(updateFlyerOrder(ownProps.side, ownProps.section, ownProps.area, order))
    },
})


const getEnhancedItemsData = (itemsData, flyerData) => {
    const enhancedItemsData = {
        order: itemsData.order,
        items: {}
    }


    itemsData.order.map(itemId => {
        const { id, type } = itemsData.items[itemId]
        let itemData 


        if(type === IMAGE) {
            itemData = flyerData.imageElements.items[itemId]
        } else if (type === TEXT) {
            itemData = flyerData.textElements.items[itemId]
        } else if (type === TITLE) {
            itemData = flyerData.headlineElements.items[itemId]
        } else if(type === METRO) {
            itemData = flyerData.metroElements.items[itemId]
        } else if(type === MOVIE_PERFORMANCES) {
            itemData = flyerData.moviePerformances.items[itemId]
        }  else if(type === GRID_IMAGE) {
            itemData = flyerData.gridImages.items[itemId]
        } else {
            itemData = false
        }

        enhancedItemsData.items[itemId] = {
            id: id,
            type: type,
            itemData: itemData
        }
    })

    return enhancedItemsData

}

const FlyerDropzoneContainer = ({
    labelTransId,
    flyerData,
    section, 
    side, 
    area,
    dndType,
    canDropTypes,
    displayDropzones,
    basicUrl,
    addFlyerItem,
    deleteFlyerItem,
    reorderFlyerItems, 
}) => {
    let listId
    let itemsData = flyerData.flyerStructure[side][section]
    let canDrop = true

    if(area) {
        listId = area
        itemsData = itemsData[area]

        if('grid' === area) {
            canDrop = itemsData.order.length < 4
        }
    } else {
        listId = section
    }

    const enhancedItemsData = getEnhancedItemsData(itemsData, flyerData)

    const canDropCallback = canDropTypes => (props, sourceObj) => canDrop && canDropTypes.includes(sourceObj.type)
    

    return (
        <ListDropItems
            listId={listId}
            title ={labelTransId ? <Translation id={labelTransId} /> : false}
            
            order={enhancedItemsData.order}
            items={enhancedItemsData.items}

            dndType={dndType}
            displayDropzones={displayDropzones}
            conditionalWrapper={ListDropConditionalWrapper}
            ChildSwitchItem={FlyerDropSwitch}
            params={false}
            basicUrl={basicUrl}

            canDropCallback={canDropTypes ? canDropCallback(canDropTypes) : null}

            canEdit={true}
            canDelete={true}
            
            addItem={(listId, itemId, itemType) => canDrop && (!canDropTypes || canDropTypes.includes(itemType)) && addFlyerItem(itemId, itemType, area)}
            reorderItem={reorderFlyerItems}
            deleteItem={(itemType, itemId) => deleteFlyerItem(itemId, false, itemType, area)}

        />
    )
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(FlyerDropzoneContainer) 